<template>
    <div>
        <video
            class="video-js"
            v-if="isSupportedVideoFormat"
            ref="videoPlayer"
            :height="height !== 0 && height"></video>
        <div
            class="video-not-supported"
            v-else>
            <div class="description">{{ $t('video_player.format_not_supported') }}</div>
            <div class="downloads">
                <b-button
                    class="btn-download btn-video-download"
                    variant="primary"
                    :href="globalOptions.sources[0].src"
                    :download="globalOptions.sources[0].src">
                    Download
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import videojs from 'video.js';

export default {
    name: 'design-2021-apprentice-video-player-component',
    props: {
        options: {
            type: Object,
            default() {
                return {};
            },
        },
        height: {
            type: Number,
            required: false,
            default: 0,
        },
    },

    data() {
        return {
            player: null,
            globalOptions: {
                fluid: true,
                responsive: true,
                playbackRates: [0.5, 1, 1.5, 2],
                sources: this.options
                    ? this.options.sources
                    : [
                          {
                              src: '',
                              type: '',
                          },
                      ],
                height: this.height,
            },
        };
    },

    computed: {
        playerOptions() {
            return Object.assign(this.globalOptions, this.options);
        },

        isSupportedVideoFormat() {
            if (
                this.playerOptions &&
                this.playerOptions.sources.length > 0 &&
                this.playerOptions.sources[0].type !== ''
            ) {
                const extension = this.playerOptions.sources[0].type.split('/');
                return extension.slice(-1).pop() !== 'avi' && extension.slice(-1).pop() !== 'mov';
            }
        },
    },

    mounted() {
        if (this.isSupportedVideoFormat) {
            this.player = videojs(this.$refs.videoPlayer, this.playerOptions, () => {
                // Todo: enable when debugging!
                // this.player.log('onPlayerReady', this);
            });
        }
    },

    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
};
</script>

<style scoped lang="scss">
.video-js ::v-deep {
    width: 100%;

    .vjs-big-play-button {
        top: calc(50% - 0.81666em);
        left: calc(50% - 1.5em);
    }
}

.video-not-supported {
    .description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    .downloads {
        width: fit-content;
    }

    .btn-video-download {
        z-index: 100;
        position: relative;
    }
}
</style>
